<template>
  <modal
    class="charge_limit_dialog"
    :show-modal="showModal"
    :show-close-button="false"
    @close="close"
  >
    <div class="charge_limit_dialog__text">
      <p class="charge_limit_dialog__title">
        {{ $t('charge_limit__alert__reached_title') }}
      </p>
      <div class="charge_limit_dialog__progress">
        <p class="charge_limit_dialog__progress_label">
          {{ $t('charge_limit__current_month_purchasable_amount') }}
        </p>
        <p class="charge_limit_dialog__progress_value">
          {{ progressText }}
        </p>
      </div>
      <p class="charge_limit_dialog__description">
        {{ descriptionText }}
      </p>
    </div>

    <PrimaryButton class="charge_limit_dialog__button" @click.native="close">
      {{ $t('buttonOK') }}
    </PrimaryButton>
  </modal>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import Formatter from '@/utils/Formatter'

@Component({
  components: {
    Modal,
    PrimaryButton,
  },
})
export default class ChargeLimitDialog extends Vue {
  @Prop({ default: false })
  showModal!: boolean

  // 当月利用額（有償コイン数。円と1:1）
  @Prop({ required: true })
  usage!: number

  // 月間上限（有償コイン数。円と1:1）
  @Prop({ required: true })
  maxLimit!: number

  // アクセス元IPのGeoIP地域が日本か否か（true の場合は円単位で表示する）。
  // アカウントの地域設定ではなく check_purchasable レスポンスの isGeoIPRegionJP を渡す
  @Prop({ default: false })
  isGeoIPRegionJP!: boolean

  @Emit('close')
  close() {}

  get isRegionJP(): boolean {
    return this.isGeoIPRegionJP
  }

  get progressText(): string {
    const usage = Formatter.numberWithCommas(this.usage)
    const maxLimit = Formatter.numberWithCommas(this.maxLimit)
    return this.isRegionJP
      ? this.$t('charge_limit__label__current_month_progress_jp', [
          usage,
          maxLimit,
        ]).toString()
      : this.$t('charge_limit__label__current_month_progress_except_jp', [
          usage,
          maxLimit,
        ]).toString()
  }

  get descriptionText(): string {
    return this.isRegionJP
      ? this.$t('charge_limit__alert__reached_description_jp').toString()
      : this.$t(
          'charge_limit__alert__reached_description_except_jp'
        ).toString()
  }
}
</script>

<style scoped>
.charge_limit_dialog >>> .modal__box {
  width: 340px;
  padding: 24px;
  border-radius: 16px;
  text-align: left;
}

.charge_limit_dialog__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  font-family: 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', sans-serif;
  font-style: normal;
}

.charge_limit_dialog__title {
  font-family: 'Hiragino Kaku Gothic Pro', 'Hiragino Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #0f0f0f;
}

.charge_limit_dialog__progress {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #0f0f0f;
}

.charge_limit_dialog__progress_label,
.charge_limit_dialog__progress_value {
  width: 100%;
}

.charge_limit_dialog__description {
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #737373;
}

.charge_limit_dialog__button {
  margin-top: 24px;
}
</style>
